import api from './axios';

// Notifications are backed by the existing ServiceReminder backend.
// No Notification table exists — due service reminders ARE the notifications.
//
// GET /reminders/due             -> overdue reminders across user's vehicles
// GET /reminders/vehicle/:vehId  -> all reminders for one vehicle (upcoming + due)

export const getDueReminders = async () => {
  const response = await api.get('/reminders/due');
  return response.data;
};

export const getVehicleReminders = async (vehicleId) => {
  if (!vehicleId) {
    throw new Error('شناسه خودرو مشخص نیست');
  }
  const response = await api.get(`/reminders/vehicle/${vehicleId}`);
  return response.data;
};

// Existing backend endpoints only (see Tasmeh-backend/src/routes/reminder.routes.js):
// PUT /reminders/:reminderId -> update interval settings (recalculates nextDueKm)
export const updateReminderSettings = async (reminderId, payload) => {
  if (!reminderId) {
    throw new Error('شناسه یادآور مشخص نیست');
  }
  const response = await api.put(`/reminders/${reminderId}`, payload);
  return response.data;
};
